import { AxiosResponse } from 'axios';
import DNDPositionalActivityProgress from '@/models/DNDPositionalActivityProgress';
import requester from '../../../lib/axios';
import { QuestionProgressAttempt } from '@/models/QuestionProgressAttempt';
import { DNDPositionalQuestionCorrectAnswer } from '@/models/QuestionCorrectAnswer';

interface DNDActivityProgressParams {
  activityId: number;
  activityProgressId: number;
}

type UpdateDndPositionalProgress = Pick<
  DNDPositionalActivityProgress,
  'isDone'
>;

export const updateDNDPositionalActivityProgress = async (
  { activityId, activityProgressId }: DNDActivityProgressParams,
  body: UpdateDndPositionalProgress,
) => {
  type Response = AxiosResponse<DNDPositionalActivityProgress>;
  const { data: dndPositionalProgress } = await requester().patch<
    UpdateDndPositionalProgress,
    Response
  >(
    `dnd-positional-activity/${activityId}/dnd-positional-activity-progress/${activityProgressId}/`,
    body,
  );
  return dndPositionalProgress;
};

type DndAttemptBody = {
  columns: { id: number; items: { id: number }[] }[];
};

export async function updateDndPositionalActivityAttempt(
  { activityProgressId, activityId }: DNDActivityProgressParams,
  body: DndAttemptBody,
) {
  const { data: attempt } = await requester().patch<QuestionProgressAttempt>(
    `dnd-positional-activity/${activityId}/dnd-positional-activity-progress/${activityProgressId}/attempt/`,
    body,
  );
  return attempt;
}

export async function getDndPositionalCorrectAnswer({
  activityProgressId,
  activityId,
}: DNDActivityProgressParams) {
  const { data } = await requester().get<DNDPositionalQuestionCorrectAnswer>(
    `dnd-positional-activity/${activityId}/dnd-positional-activity-progress/${activityProgressId}/correct-answer/`,
  );
  return data;
}
